import { ICommandTask } from "../models/application.model";
import ResourceFactory from "./resource";

const resourceKey = "tasksCommandCenter";
const resourceUrl = "applications/command/tasks";
const resourceIdKey = "id";

const { reducer, fetchList } = ResourceFactory<ICommandTask>(resourceKey, resourceUrl, resourceIdKey);

export type TasksCommandCenterResourcesState = ReturnType<typeof reducer>;
export const fetchTasksList = fetchList;

export default reducer;
